/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Capture_HelpInputs */

const en_mobile_scan_capture_help = /** @type {(inputs: Mobile_Scan_Capture_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photograph one page at a time. Keep the text in focus and avoid glare. Adjust the crop after taking your photos.`)
};

const es_mobile_scan_capture_help = /** @type {(inputs: Mobile_Scan_Capture_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografía una página a la vez. Mantén el texto enfocado y evita los reflejos. Ajusta el recorte después de tomar las fotos.`)
};

/**
* | output |
* | --- |
* | "Photograph one page at a time. Keep the text in focus and avoid glare. Adjust the crop after taking your photos." |
*
* @param {Mobile_Scan_Capture_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_capture_help = /** @type {((inputs?: Mobile_Scan_Capture_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Capture_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_capture_help(inputs)
	return en_mobile_scan_capture_help(inputs)
});